export default {
  GET_DEPARTMENTS: ({ page = 1, rowsPerPage = 10 }) =>
    `departments/?page=${page}&page_size=${rowsPerPage}`,
  GET_AUDIT_DEPARTMENTS: 'departments/?is_active=true',
  CREATE_DEPARTMENT: 'departments/',
  UPDATE_DEPARTMENT: (id) => `departments/${id}/`,
};
